import { CM_BASE_URL } from '../../pages/constants/cmConstants';
import { axios } from './common';
import { convertFilterEpochForBackend } from '../../util/timezone';

export const fetchWhiteList = async ({ searchText, currentPage, pageSize }) => {
  const params = {
    'search-text': searchText,
    offset: (currentPage - 1) * pageSize,
    limit: pageSize
  };

  const url = `${CM_BASE_URL}/whitelists`;

  return axios.get(url, { params }).then((res) => {
    if (res.status !== 200) {
      throw new Error('Failed to fetch whitelist data');
    }
    return res.data;
  });
};

export const fetchWhiteListDetails = async ({
  id,
  currentPage,
  pageSize,
  filters
}) => {
  const params = {
    offset: (currentPage - 1) * pageSize,
    limit: pageSize,
    from: convertFilterEpochForBackend(filters.from),
    to: convertFilterEpochForBackend(filters.to)
  };

  if (filters.searchText) {
    params['search-text'] = filters.searchText;
  }

  const url = `${CM_BASE_URL}/whitelists/${id}/customers`;

  return axios.get(url, { params }).then((res) => {
    if (res.status !== 200) {
      throw new Error(res?.data?.error ?? 'Failed to fetch whitelist details');
    }

    return res.data;
  });
};

export const getAlertGeneration = async () => {
  const url = `${CM_BASE_URL}/static-property`;

  return axios.get(url).then((res) => {
    if (res.status !== 200) {
      throw { message: 'Failed to fetch alert generation value' };
    }
    return res.data;
  });
};

export const deleteWhitelist = async ({ id }) => {
  const url = `${CM_BASE_URL}/whitelists/${id}`;

  return axios
    .delete(url)
    .then((res) => {
      if (res.status !== 200) {
        throw new Error('Failed to delete whitelist');
      }
      return res.data;
    })
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const updateAlertGeneration = async ({ id, propertyValue }) => {
  const params = {
    staticPropertyValue: propertyValue
  };
  const url = `${CM_BASE_URL}/static-property/${id}/value`;

  return axios
    .post(url, { params })
    .then((res) => {
      if (res.status !== 200) {
        throw new Error('Failed to update alert gen');
      }
      return res.data;
    })
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const addCustomerDetails = async ({ whitelistId, customerDetails }) => {
  const url = `${CM_BASE_URL}/whitelists/${whitelistId}/customers`;

  return axios
    .post(url, customerDetails)
    .then((res) => {
      if (res.status !== 200 && res.status !== 201) {
        throw new Error(res?.data?.error || 'Failed to add the party details');
      }

      return res.data;
    })
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const updateCustomerDetails = async ({ id, endDate }) => {
  const url = `${CM_BASE_URL}/whitelists/customer/${id}`;

  return axios
    .put(url, { endDate })
    .then((res) => {
      if (res.status !== 200) {
        throw new Error(res?.data?.error);
      }

      return res.data;
    })
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const approveCustomers = async ({ customerIds, whitelistId }) => {
  const url = `${CM_BASE_URL}/whitelists/approveCustomers`;

  return axios
    .put(url, { customersIds: customerIds, whitelistId })
    .then((res) => {
      if (res.status !== 200) {
        throw new Error('Failed to approve parties');
      }
      return res.data;
    })
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const deleteCustomers = async ({ customerIds, whitelistId }) => {
  const url = `${CM_BASE_URL}/whitelists/${whitelistId}/deleteCustomers/${customerIds.join(
    ','
  )}`;

  return axios
    .delete(url)
    .then((res) => {
      if (res.status !== 200) {
        throw new Error('Failed to delete parties');
      }
      return res.data;
    })
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const addWhitelistName = async ({ whitelistName }) => {
  const url = `${CM_BASE_URL}/whitelists`;

  return axios.post(url, { whitelistName }).then((res) => {
    if (res.status !== 200) {
      throw new Error(res?.data?.error);
    }

    return res.data;
  });
};

export const updateWhitelistName = async ({ id, name }) => {
  const url = `${CM_BASE_URL}/whitelists/${id}/name`;

  return axios
    .put(url, { name })
    .then((res) => {
      if (res.status !== 200) {
        throw new Error(res?.data?.error);
      }

      return res.data;
    })
    .catch((error) => {
      throw new Error(error.message);
    });
};
